<template>
  <svg
    class="ArrowAsBack"
    width="61"
    height="50"
    viewBox="0 0 61 50"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 12C14 12 6.78324 19.2045 2 24.0345L13.9991 36"
      stroke="black"
      stroke-width="2.6"
    />
    <path d="M60.1265 24H2.12647" stroke="black" stroke-width="3" />
  </svg>
</template>
<script>
export default {
  name: "ArrowAsBack",
};
</script>
<style scoped>
svg.ArrowAsBack {
  vertical-align: top;
}
</style>



// WEBPACK FOOTER //
// src/components/ArrowAsBack.vue